import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { NAMESPACES } from '@/i18n/namespaces';
import { APP_BACKEND_URL } from '@/utils/config';

interface AuthModalContentProps {
  onClose: () => void;
  mode: 'signup' | 'login';
}

const AuthModalContent: React.FC<AuthModalContentProps> = ({ onClose, mode }) => {
  const { t } = useTranslation(NAMESPACES.WELCOME);
  
  // Determine the redirect URL based on mode
  const emailRedirectUrl = mode === 'signup' ? '/signup' : '/login';
  
  return (
    <div className="flex flex-col w-full m-0 p-0">
      {/* Social Login Links Wrapper */}
      <div className="flex flex-col w-full" style={{ marginLeft: '24px', marginRight: '24px', maxWidth: 'calc(100% - 48px)' }}>
        <a 
          href={`${APP_BACKEND_URL}/sign-in/google`} 
          className="btn flex justify-center items-center bg-white text-black font-medium w-full mb-2" 
          style={{ backgroundColor: '#fff', color: '#000', maxWidth: '100%', boxSizing: 'border-box' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 20" fill="none" className="mr-3">
            <path d="M18.18 10.1832C18.18 9.61597 18.1291 9.07051 18.0345 8.54688H10.5V11.6451H14.8055C14.6164 12.6414 14.0491 13.4851 13.1982 14.0523V16.0669H15.7945C17.3073 14.6705 18.18 12.6196 18.18 10.1832Z" fill="#4285F4"/>
            <path d="M10.4997 18.0001C12.6597 18.0001 14.4706 17.2873 15.7943 16.0655L13.1979 14.051C12.4852 14.531 11.5761 14.8219 10.4997 14.8219C8.41973 14.8219 6.65246 13.4183 6.01973 11.5273H3.35791V13.5928C4.67427 16.2037 7.37246 18.0001 10.4997 18.0001Z" fill="#34A853"/>
            <path d="M6.02 11.5195C5.86 11.0395 5.76545 10.5304 5.76545 9.99952C5.76545 9.46861 5.86 8.95952 6.02 8.47952V6.41406H3.35818C2.81273 7.49043 2.5 8.70497 2.5 9.99952C2.5 11.2941 2.81273 12.5086 3.35818 13.585L5.43091 11.9704L6.02 11.5195Z" fill="#FBBC05"/>
            <path d="M10.4997 5.18545C11.6779 5.18545 12.7252 5.59273 13.5615 6.37818L15.8525 4.08727C14.4634 2.79273 12.6597 2 10.4997 2C7.37246 2 4.67427 3.79636 3.35791 6.41455L6.01973 8.48C6.65246 6.58909 8.41973 5.18545 10.4997 5.18545Z" fill="#EA4335"/>
          </svg>
          {t('modal.socialLogin.google')}
        </a>
        
        <a 
          href={`${APP_BACKEND_URL}/sign-in/apple`} 
          className="btn flex justify-center items-center font-medium border border-[#333] w-full" 
          style={{ backgroundColor: '#000', color: '#fff', maxWidth: '100%', boxSizing: 'border-box' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="mr-3">
            <path d="M15.9089 7.45433C15.8139 7.52633 14.1366 8.44952 14.1366 10.5023C14.1366 12.8767 16.2709 13.7167 16.3348 13.7375C16.325 13.7887 15.9957 14.8878 15.2095 16.0078C14.5085 16.9934 13.7763 17.9774 12.6625 17.9774C11.5486 17.9774 11.262 17.3454 9.97616 17.3454C8.72311 17.3454 8.27758 17.9982 7.25875 17.9982C6.23993 17.9982 5.52904 17.0862 4.71169 15.9662C3.76494 14.651 3 12.6079 3 10.6687C3 7.55833 5.07041 5.90875 7.10806 5.90875C8.19076 5.90875 9.09329 6.60314 9.77305 6.60314C10.4201 6.60314 11.4291 5.86715 12.6608 5.86715C13.1276 5.86715 14.8049 5.90875 15.9089 7.45433ZM12.0761 4.55037C12.5855 3.95998 12.9458 3.14079 12.9458 2.3216C12.9458 2.208 12.936 2.0928 12.9147 2C12.0859 2.0304 11.0998 2.53919 10.5052 3.21279C10.0384 3.73118 9.6027 4.55037 9.6027 5.38076C9.6027 5.50556 9.624 5.63035 9.63382 5.67035C9.68624 5.67995 9.77141 5.69115 9.85659 5.69115C10.6002 5.69115 11.5355 5.20476 12.0761 4.55037Z" fill="white"/>
          </svg>
          {t('modal.socialLogin.apple')}
        </a>
      </div>
      
      {/* Separator */}
      <div 
        style={{ 
          borderTop: '1px solid rgba(255, 255, 255, 0.06)',
          marginTop: '24px',
          marginBottom: '24px',
          width: '100%'
        }}
      ></div>
      
      {/* Email Option */}
      <div style={{ marginLeft: '24px', marginRight: '24px', maxWidth: 'calc(100% - 48px)', width: '100%', marginBottom: '24px' }}>
        <Link
          to={emailRedirectUrl}
          className="btn btn-secondary w-full"
          onClick={onClose}
          style={{ maxWidth: '100%', boxSizing: 'border-box' }}
        >
          {t('modal.socialLogin.email')}
        </Link>
      </div>
    </div>
  );
};

export default AuthModalContent; 